import React, { useEffect, useRef, useState } from 'react';
import { Alert, Avatar, Button, Card, Checkbox, Col, Divider, Form, Input, Row, Select, Spin, Tabs, Tooltip,  } from 'antd';
import QuestionItem from './QuestionItem';
import AddQuestionButton from './AddQuestionButton';
import SubmitButton from './shared/SubmitButton';
import DescriptionInput from './shared/DescriptionInput';
import FormTitleInput from './shared/FormTitleInput';
import "./forms.css";
import "./shared/shared.css";
import { ArrowLeftOutlined,  BellOutlined, CaretDownOutlined, DeliveredProcedureOutlined, EyeOutlined, FileTextFilled, FontSizeOutlined, InfoCircleOutlined, LockOutlined, PictureOutlined, PlusCircleOutlined, QuestionCircleOutlined, SettingOutlined, UserAddOutlined } from '@ant-design/icons';
import AvatarConnected from "./../../assets/img/imgProfil.png";
import BtnSimpl from '../buttons/BtnSimpl';
import ModalComponent from '../modals/ModalComponent';
import { BiWorld } from 'react-icons/bi';
import Title from 'antd/es/typography/Title';
import TextArea from 'antd/es/input/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { createFormulaire } from '../../redux/actions/FormBuilderActions';
// import {publishFormulaire} from '../../redux/actions/PublishFormActions';
import {getTypeLabel, getTypeIcon} from "./../../services/util";
// import DetailsForm from '../../pages/formulaires/DetailsForm';
import { ListFormsActions } from '../../redux/actions/ListFormsActions';
import Parametres from '../../pages/parametres/Parametres';

// const { Option } = Select;

const FormBuilder = ({ onRetour, onSuccess }) => {
  const [form] = Form.useForm();

  const [title, setTitle] = useState('Formulaire sans titre');
  const [description, setDescription] = useState('');
const [isFocused, setIsFocused] = useState(false);
const [accessLevel, setAccessLevel] = useState("Limité");
const [selectionRepondant, setSelectionRepondant] = useState("PublicResponse");
// const [donneeEnregistree, setDonneeEnregistree] = useState();
const dispatch = useDispatch();
 const [questions, setQuestions] = useState([
  {
    id: null,
    label: '',
    type: 'radio',
    required: false,
    options: [],
    isCollapsed: false, 
  },
]);



localStorage.setItem("previewForm", JSON.stringify({ title, description, questions }));


const [reduir, setReduir] = useState(false);

const [openModal, setOpenModal] = useState();
// const handleOpenModal = () => {
//   setOpenModal(true);
// }
 const handleCloseModal = () => {
    setOpenModal(false);
 };

 const [openModalPartage, setOpenModalPartage] = useState();
 const handleOpenModalPartage = () => {
  setOpenModalPartage(true);
  setReduir(true);
 }
 const handleCloseModalPartage = () => {
  setOpenModalPartage(false);
 }



const handleAddModelQuestion = () => {
  const updated = questions.map(q => ({ ...q, isCollapsed: true }));
  const newQuestion = {
    id: Date.now(),
    label: '',
    type: 'radio',
    required: false,
    options: [],
    isCollapsed: false, 
  };

  setQuestions([...updated, newQuestion]);
  
};

// const {  form: formById, error } = useSelector((state) => state.getFormById);

  // console.log(formById);

  // useEffect(() => {
  //   if (id) {
  //     dispatch(getFormById(id));
  //   }
  // }, [dispatch, id]);

const { loading: loadingFormB8lder } = useSelector((state) => state.creatFormulaireBuilder);
const userConnectedData= localStorage.getItem("user");
const parsedUser = JSON.parse(userConnectedData);


const handleSubmitFormB8lder = async () => {
  const formData = {
    title,
    description,
    userId: parsedUser.id, 
    fields: questions.map(q => ({
      label: q.label,
      type: q.type,
      required: q.required,
      ...(q.options?.length > 0 ? { options: q.options } : {}),
    })),
  };
  // console.log(formData);

 const result = await dispatch(createFormulaire(formData));
 await dispatch(ListFormsActions());
  // console.log(result);

  if (result) {
  if (onSuccess) {
    onSuccess(result); 
  }
}
//  console.log(onSuccess);

  // setDonneeEnregistree(result);
  //  <DetailsForm dataForm={donneeEnregistree} />

   setTitle("Formulaire sans titre");
  setDescription("");
  setQuestions([
    {
      id: null,
      label: '',
      type: 'radio',
      required: false,
      options: [],
      isCollapsed: false,
    },
  ]);

};

// onRetour={() => setView("details")}

 
const activeCardRef = useRef(null);
const lateralRef = useRef(null);

useEffect(() => {
  if (activeCardRef.current && lateralRef.current) {
    const cardRect = activeCardRef.current.getBoundingClientRect();
    const containerRect = document.querySelector(".stylRowCard")?.getBoundingClientRect();

    const offset = cardRect.top - containerRect.top;
    lateralRef.current.style.transform = `translateY(${offset}px)`;
    lateralRef.current.style.transition = "transform 0.3s ease-in-out";
  }
}, [questions]); // ou [questions.find(q => !q.isCollapsed)]

 
  const itemsTab = [
  { key: '1', label: 'Questions', 
  children: 
        <Row gutter={25} className="stylRowCard" justify="center" align="top">
      {/* Colonne principale */}
      <Col span={18}>
        <Form form={form} onFinish={handleSubmitFormB8lder}>
          {/* Titre / description */}
          <Card className="cardTitleDescriptionInput">
            <FormTitleInput
              name="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="titrFormulaire"
              variant="borderless"
            />
            <DescriptionInput
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Card>

          {/* Questions */}
          {questions.map((question, index) => (
            <Card
              key={`${question.id}-${index}`}
              ref={!question.isCollapsed ? activeCardRef : null}
              className={question.isCollapsed ? "" : "stylDefaultCard"}
              style={{ marginTop: "2%", cursor: "pointer" }}
              onClick={() => {
                const updated = questions.map((q, i) => ({
                  ...q,
                  isCollapsed: i !== index,
                }));
                setQuestions(updated);
              }}
            >
              {question.isCollapsed ? (
                <>
                  <div style={{ padding: "2%", fontSize: "15px", fontWeight: "500", color: "#444" }}>
                    {question.label || "Question sans titre"}
                  </div>
                  <div style={{ marginTop: "3%" }}>
                    <QuestionItem question={question} isCollapsed />
                  </div>
                </>
              ) : (
                <>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 20 }}>
                    <Input
                      placeholder="Question"
                      variant="underlined"
                      value={question.label}
                      onChange={(e) => {
                        const updated = [...questions];
                        updated[index].label = e.target.value;
                        setQuestions(updated);
                      }}
                      style={{ width: "70%", padding: "2.5%", backgroundColor: "#F1F3F4" }}
                    />
                    <PictureOutlined style={{ fontSize: 22 }} />
                    <BtnSimpl
                      float_="right"
                      buttonText_={getTypeLabel(question.type)}
                      htmlType_="button"
                      borderRadius_="0.5rem"
                      border_
                      width_="100%"
                      height_="8vh"
                      prefix_={getTypeIcon(question.type)}
                      suffix_={
                        <AddQuestionButton
                          onAdd={(type) => {
                            const updated = [...questions];
                            updated[index].type = type;
                            setQuestions(updated);
                          }}
                        />
                      }
                    />
                  </div>
                  <div style={{ marginTop: "3%" }}>
                    <QuestionItem
                      question={question}
                      onChangeOptions={(newOptions) => {
                        const updated = [...questions];
                        updated[index].options = newOptions;
                        setQuestions(updated);
                      }}
                      onDelete={() => {
                        setQuestions((prev) => {
                          const indexToDelete = prev.findIndex((q) => q.id === question.id);
                          const updated = prev.filter((q) => q.id !== question.id);
                          if (updated.length === 0) return [];
                          const newIndexToActivate = indexToDelete > 0 ? indexToDelete - 1 : 0;
                          return updated.map((q, i) => ({
                            ...q,
                            isCollapsed: i !== newIndexToActivate,
                          }));
                        });
                      }}
                      onDuplicate={() => {
                        setQuestions((prev) => {
                          const indexToDuplicate = prev.findIndex((q) => q.id === question.id);
                          const duplicated = {
                            ...question,
                            id: Date.now(),
                            isCollapsed: false,
                          };
                          const updated = prev.map((q) => ({ ...q, isCollapsed: true }));
                          updated.splice(indexToDuplicate + 1, 0, duplicated);
                          return updated;
                        });
                      }}
                      onToggleRequired={(id) =>
                        setQuestions((prev) =>
                          prev.map((q) =>
                            q.id === id ? { ...q, required: !q.required } : q
                          )
                        )
                      }
                    />
                  </div>
                </>
              )}
            </Card>
          ))}

          {/* Bouton de soumission */}
          <br />
          <div>
            <Spin
              className="spinLoading"
              style={{ marginLeft: "43%", marginTop: "3%" }}
              spinning={loadingFormB8lder}
              tip="Envoie en cours..."
              size="large"
            >
              <SubmitButton
                htmlType_="submit"
                className_="stylBtnSubmitForm"
                children="Enregistrer"
                disabled_={loadingFormB8lder}
              />
            </Spin>
          </div>
        </Form>
      </Col>

      {/* Barre latérale */}
      <Col span={2} style={{ position: "relative" }}>
        <div className="stylColLateral" ref={lateralRef}>   
          <br/>       
          <Tooltip title="Ajouter une question">
            <PlusCircleOutlined
              onClick={handleAddModelQuestion}
              style={{ fontSize: 24 }}
            />
          </Tooltip>
          <br />
          {/* <br /> */}
          {/* <Tooltip title="Importer des questions">
            <DeliveredProcedureOutlined style={{ fontSize: 22 }} />
          </Tooltip>
          <br />
          <br />
          <Tooltip title="Ajouter un titre et une description">
            <FontSizeOutlined style={{ fontSize: 22 }} />
          </Tooltip>
          <br />
          <br />
          <Tooltip title="Ajouter une image">
            <PictureOutlined style={{ fontSize: 22 }} />
          </Tooltip> */}
        </div>
      </Col>
    </Row>},
  { key: '2', label: 'Réponses', children: <>
    <Card > <Title level={3} style={{ margin:0, padding:0}}> 0 réponse</Title></Card>
    <Card style={{marginTop:20,}}><p style={{fontSize:13, textAlign:"center", margin:0, padding:0, color:"#70757A"}}>Aucune réponse. Publiez votre formulaire pour commencer à recevoir des réponses.</p></Card>
  </>},
  { key: '3', label: 'Paramètres', children: <Parametres /> },
];


 const renderIcon = () => {
    if ((accessLevel === "Limité") || (selectionRepondant === "limiteResponse")) {
      return (
        <Avatar size="default">
          <LockOutlined style={{ fontSize: 18, color: "#000" }} />
        </Avatar>
      );
    } 
    else {
        return (
        <Avatar size={37} style={{ backgroundColor: "#E8FCE2" }}>
          <BiWorld style={{ color: "#43CE0C", fontSize: 25, marginTop: 5 }} />
        </Avatar>
      );
    }
  };

   const renderIcon2 = () => {
    if (selectionRepondant === "limiteResponse") {
      return (
        <Avatar size="default">
          <LockOutlined style={{ fontSize: 18, color: "#000" }} />
        </Avatar>
      );
    } 
    else {
        return (
        <Avatar size={37} style={{ backgroundColor: "#E8FCE2" }}>
          <BiWorld style={{ color: "#43CE0C", fontSize: 25, marginTop: 5 }} />
        </Avatar>
      );
    }
  };

  

 const handleRetourPrecedent = () => {
    if (onRetour) onRetour();
 }

  // const [isChecked, setIsChecked] = useState(true);

  // const onChangeSwitch = (checked) => {
  //   setIsChecked(checked);
  // };

  return (
    <div className='stylDivGB'>
      <Row justify="end"> <Col><BtnSimpl onClick_={handleRetourPrecedent} boldColor_={600} color_="#43CE0C" border_="1px solid #43CE0C" buttonText_="Retour" htmlType_="button" /></Col></Row>
      <Row gutter={10} >
        <Col span={14} className='stylCol1'>
          <FileTextFilled className='stylIconeFifileText' />
          <FormTitleInput value={title} onChange={(e) => setTitle(e.target.value)} variant="borderless" className="titrFormulaire2" />
          {/* <FolderOutlined style={{fontSize:22}} /> <StarOutlined style={{fontSize:22, marginLeft:"3%"}} /> */}
        </Col>

          <Col span={10} className='stylCol2'>
                  <a href={`${window.location.origin}/viewForm`} target="_blank" rel="noopener noreferrer"><Tooltip title="Aperçu"><EyeOutlined style={{fontSize:22, color:"#000"}} /></Tooltip> </a>
                  {/* <Tooltip title="Copier le lien pour les répondants"><LinkOutlined style={{fontSize:22}}/></Tooltip> */}
                  {/* <Tooltip title="Partager"><UserAddOutlined style={{fontSize:22}}/></Tooltip> */}
                    
                    <SubmitButton  htmlType_="button" disabled_
                    children="Publier" className_="stylBoutonPub" />
                    <Avatar><img src={AvatarConnected} alt="imag"/></Avatar>
          </Col>

      </Row>
      
         <Tabs
            defaultActiveKey="1"
            centered
            items={itemsTab}
          />

      {/* LES MODALS */}

         <div style={{width:"100%"}}>
                            <ModalComponent  
                                _title={<div style={{fontSize:25, fontWeight:"normal", }}>Publier le formulaire</div>}
                                // _width="35%"
                                _padding={0}
                                _maskClosable={false}
                                _closable={true} 
                                _open={openModal}
                                _onCancel={handleCloseModal}
                                _form={ 
                                   <div>
                                     <Divider style={{marginTop:12, marginBottom:15}} />
                                    <div style={{fontSize:19, fontWeight:500, marginBottom:"2%"}}><UserAddOutlined style={{fontSize:22, marginRight:"4%"}} />Répondants</div>
                                    
                                    <Row>
                                      <Col span={20}>
                                      <Avatar size="small" style={{backgroundColor:"#E8FCE2", marginLeft:"9%", marginRight:"3%"}}> <BiWorld style={{color:"#43CE0C",  }} /></Avatar>
                                        Tous les utilisateurs qui ont le lien
                                      </Col>
                                      <Col span={4}><Button type="link" onClick={handleOpenModalPartage}>Gérer</Button></Col>
                                    </Row>
                                     
                                     <Divider style={{marginTop:12, marginBottom:15}} />
                                     <div style={{display:"flex", }}>
                                       <BellOutlined style={{fontSize:22, marginRight:"3%"}}/><p> Personne ne recevra de notification lors de la publication du formulaire</p>
                                      </div>
                                      <Divider style={{marginTop:12, marginBottom:15}} />
                                      <div style={{textAlign:"right", padding:10, margin:0,}}>
                                         <SubmitButton  onClick_={handleCloseModal} htmlType_="button" children="Ignorer" className_="stylBoutonIgnorer" />  
                                          <SubmitButton  htmlType_="submit" children="Publier" className_="stylBoutonPub" />
                                      </div>
                                    
                                   </div>
                                }
                            />
          </div>


          <div style={{width:"100%"}}>
                            <ModalComponent  
                                _title={<Row style={{marginTop:"-1.3%"}}> {isFocused && (<ArrowLeftOutlined onClick={() => {setReduir(true); setIsFocused(false);}} style={{fontSize:18, marginRight:"4%"}} />)}<Col span={18} style={{fontSize:25, fontWeight:"normal", }}>Partager</Col>   <Col span={4} style={{fontSize:18, }}><QuestionCircleOutlined /><SettingOutlined style={{marginLeft:"20%"}} /></Col></Row>}
                                _padding={0}
                                _maskClosable={false}
                                _closable={true} 
                                _open={openModalPartage}
                                _onCancel={handleCloseModalPartage}
                                _form={ 
                                   <div>
                                     <Row gutter={8}>
                                      <Col span={isFocused ? 18 : 24}>
                                        <Select
                                          name="email"
                                          type="email"
                                          mode="tags"
                                          className="stylSelectEmail"
                                          placeholder={
                                            <div style={{ marginTop: "4.5%", color: "#000" }}>
                                              Ajouter des personnes, des groupes et des évenements d'agenda
                                            </div>
                                          }
                                          onChange={() => {
                                            setIsFocused(true);
                                            setReduir(false);
                                          }}
                                          // options={options}
                                        />
                                      </Col>

                                      {(!reduir && isFocused) && (
                                        <Col span={4}>
                                          <Button style={{ height: "8vh", border: "1px solid" }}>
                                            Répondant <CaretDownOutlined />
                                          </Button>
                                        </Col>
                                      )}
                                    </Row>


                                      { reduir && (
                                        <>
                                      <Title level={4}>Utilisateurs avec accès</Title>
                                      <Row>
                                        <Col span={2} style={{marginTop:7}}><Avatar size="default" style={{backgroundColor:"#E8FCE2"}}> <p style={{color:"#43CE0C", fontSize:20}}> U </p></Avatar></Col>
                                        <Col span={18}>
                                         <strong style={{fontSize:16}}> Mariama Cissé (you) </strong><br/>
                                           mariama@gmail.com
                                        </Col>
                                         <Col span={4}>Proprietaire</Col>
                                      </Row>
                                      
                                        {/* <div> <Title level={4}>Accès général</Title></div>
                                      <Row>
                                        <Col span={2} style={{marginTop:"2.5%", marginRight:"1.5%"}}> {renderIcon()}</Col>
                                           <Col span={20}>
                                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span>Vue Éditeur</span>
                                        <Button type="text">
                                        <Select className='stylSelectOptionModal2'
                                          value={accessLevel}
                                          onChange={(value) => setAccessLevel(value)}
                                          suffixIcon={<CaretDownOutlined />}
                                          bordered={false}
                                           dropdownRender={(menu) => (
                                            <>
                                              {menu}
                                              {accessLevel === "Public" && (<>
                                              <Divider  style={{ margin: "8px 0" }} />
                                              <div
                                                onClick={() => {
                                                  console.log("Lien supprimé");
                                                  setAccessLevel("Limité"); // Optionnel : revenir à Limité
                                                }}
                                                  style={{ padding: "8px 12px", cursor: "pointer", }}
                                              >
                                                Supprimer le lien
                                              </div>
                                              </>)}
                                            </>
                                          )}
                                        >
                                          <Option value="Limité">Limité</Option>
                                          <Option value="Public">Tout les utilisateurs qui ont le lien</Option>
                                        </Select></Button>
                                      </div>

                                      <div style={{ marginTop: 8 }}>
                                        {accessLevel === "Limité" ? (
                                          <span style={{ fontSize: 13 }}>
                                            Seules les personnes avec accès peuvent l'ouvrir à l'aide du lien
                                          </span>
                                        ) : (
                                          <>
                                          <Col span={4} style={{ float:"right" }}>Éditeur</Col>
                                          <span style={{ fontSize: 13 }}>
                                            Tous les internautes disposant du lien peuvent modifier l'élément
                                          </span>
                                            
                                          </>
                                        )}
                                      </div>
                                    </Col>

                                      </Row><br/>

                                         <Row>
                                        <Col span={2} style={{marginTop:"2.5%", marginRight:"1.5%"}}> {renderIcon2()}</Col>
                                           <Col span={18}>
                                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span>Vue Personne interrogée</span>
                                        <Button type="text">
                                        <Select className='stylSelectOptionModal2'
                                          value={selectionRepondant}
                                          onChange={(value) => setSelectionRepondant(value)}
                                          suffixIcon={<CaretDownOutlined />}
                                          bordered={false}
                                           dropdownRender={(menu) => (
                                            <>
                                              {menu}
                                              {selectionRepondant === "PublicResponse" && (<>
                                              <Divider  style={{ margin: "8px 0" }} />
                                              <div
                                                onClick={() => {
                                                  console.log("Lien supprimé");
                                                  setAccessLevel("Tout les utilisateurs qui ont le lien"); // Optionnel : revenir à Limité
                                                }}
                                                  style={{ padding: "8px 12px", cursor: "pointer", }}
                                              >
                                                Supprimer le lien
                                              </div>
                                              </>)}
                                            </>
                                          )}
                                        >
                                          <Option value="limiteResponse">Limité</Option>
                                          <Option value="PublicResponse">Tout les utilisateurs qui ont le lien</Option>
                                        </Select></Button>
                                      </div>

                                      <div style={{ marginTop: 8 }}>
                                        {selectionRepondant === "PublicResponse" ? (
                                          <>
                                           <Col span={4} style={{ float:"right" }}>Répondant</Col>
                                          <span style={{ fontSize: 13 }}>
                                             Tous les internautes disposant du lien peuvent répondre
                                          </span></>
                                        ) : (
                                          <span style={{ fontSize: 13 }}>
                                           Seules les personnes avec accès peuvent l'ouvrir à l'aide du lien
                                          </span>
                                        )}
                                      </div>
                                    </Col>

                                      </Row><br/> */}

                                      </>
                              )}

                                     { (!reduir && isFocused) && ( <>
                                     <br/>
                                      <Checkbox 
                                        // onChange={onChange}
                                      > Envoyer une notification</Checkbox>
                                      <TextArea
                                        // value={value}
                                        // onChange={e => setValue(e.target.value)}
                                        autoSize={{ minRows: 5, maxRows: 20 }}
                                      /> <br/></>)}
                                    <br/>
                                     
                                        <Alert icon={<InfoCircleOutlined style={{color:"#0C0484", fontSize:20}}/>} showIcon message="Publiez le formulaire pour accepter les réponses" type="info" style={{color:"primary", border:"none", padding:"3%"}}  /><br/>
                                     
                                     {reduir && ( <div style={{textAlign:"right", }}><Button type="primary" htmlType='button' style={{backgroundColor:"#43CE0C", borderRadius:"2rem", padding:"4.5%", border:"none"}}>OK</Button></div>)}
                                     
                                     { (!reduir && isFocused) && (<div style={{display:"flex", justifyContent:"end", gap:10,  }}>
                                        <Button  htmlType='button' style={{borderRadius:"2rem", padding:"4.5%", border:"none", color:"#43CE0C"}}>Annuler</Button>
                                        <Button type="primary" htmlType='button' style={{backgroundColor:"#43CE0C", borderRadius:"2rem", padding:"4.5%", border:"none"}}>Partager</Button>
                                     </div>)}
                                      
                                    
                                   </div>
                                }
                            />
          </div>


           

    </div>
    
  );
};
 
export default FormBuilder;

